import { IconX } from '@leland-dev/leland-ui-library';
import { type FC, useState } from 'react';

import {
  ReviewsBreakdown,
  type ReviewsBreakdownProps,
} from './ReviewsBreakdown';

export const MobileReviewsBreakdown: FC<ReviewsBreakdownProps> = (props) => {
  const [showReviewBreakdown, setShowReviewBreakdown] = useState(false);
  return (
    <>
      <div className="flex w-full items-center justify-between">
        <span className="text-2xl font-medium">Leland Reviews</span>
        <button
          className="text-leland-gray-extra-light underline hover:cursor-pointer hover:text-leland-gray-light"
          onClick={() => setShowReviewBreakdown(true)}
          id="mobile_reviews_breakdown--view_review_breakdown"
        >
          Breakdown
        </button>
      </div>
      {showReviewBreakdown ? (
        <div className="fixed inset-0 w-full bg-leland-black/50">
          <div className="absolute inset-x-0 bottom-0 rounded-t-lg bg-leland-white p-4">
            <ReviewsBreakdown {...props} />
            <button
              className="absolute right-4 top-4 rounded-full border p-1"
              onClick={() => setShowReviewBreakdown(false)}
              id="mobile_reviews_breakdown--close_review_breakdown"
            >
              <IconX className="size-4 hover:cursor-pointer hover:text-leland-gray-light" />
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
};
